<div class="row">
    <div class="col">
        <p class="title"> 27th - Main Hall </p>
        <a mat-button href="/cifris24/program#fcir24-i" class="txtbtn-workshop">FCiR24 I</a>
        <a mat-button href="/cifris24/program#fcir24-ii" class="txtbtn-workshop">FCiR24 II</a>
        <a mat-button href="/cifris24/program#readpqc24" class="txtbtn-workshop">ReAdPQC24</a>
    </div>
    <div class="col">
        <p class="title"> 27th - Room A </p>
        <a mat-button href="/cifris24/program#tac24-i" class="txtbtn-workshop">TAC24 I</a>
        <a mat-button href="/cifris24/program#tac24-ii" class="txtbtn-workshop">TAC24 II</a>
    </div>
    <div class="col">
        <p class="title"> 27th - Room B </p>
        <a mat-button href="/cifris24/program#ntc24" class="txtbtn-workshop">NTC24</a>
        <a mat-button href="/cifris24/program#qcifris24" class="txtbtn-workshop">QCifris24</a>
    </div>
    <div class="col">
        <p class="title"> 27th - Room C </p>
        <a mat-button href="/cifris24/program#symcrypt24" class="txtbtn-workshop">SymCrypt24</a>
        <a mat-button href="/cifris24/program#codemath24" class="txtbtn-workshop">CodeMath24</a>
    </div>
    <div class="col">
        <p class="title"> 27th - Room D </p>
        <a mat-button href="/cifris24/program#cpsid24" class="txtbtn-workshop">CPSID24</a>
        <a mat-button href="/cifris24/program#cifriscloud24" class="txtbtn-workshop">CifrisCloud24</a>
    </div>
</div>